/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Collection_EyebrowInputs */

const en_home_collection_eyebrow = /** @type {(inputs: Home_Collection_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Stay Awaits`)
};

/**
* | output |
* | --- |
* | "Your Stay Awaits" |
*
* @param {Home_Collection_EyebrowInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_collection_eyebrow = /** @type {((inputs?: Home_Collection_EyebrowInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Collection_EyebrowInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_collection_eyebrow(inputs)
});